import { GlobalNav } from "@/components/layouts/global-nav"

export function NotFound() {
  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <main>
          <div className="flex flex-col items-center justify-center min-h-screen">
            <div className="text-center">
              <h1 className="text-lg font-bold text-gray-600">404</h1>
              <h1 className="text-lg font-bold text-gray-600">ページが見つかりません</h1>
              <p className="mt-4 text-sm text-gray-400">
                お探しのページは存在しないか、
                <br />
                移動された可能性があります。
              </p>
            </div>
          </div>
        </main>
      </div>
      <GlobalNav />
    </>
  )
}
